import { render, staticRenderFns } from "./PsAdministrationPanel.vue?vue&type=template&id=e2e9eeea&scoped=true&"
import script from "./PsAdministrationPanel.vue?vue&type=script&lang=js&"
export * from "./PsAdministrationPanel.vue?vue&type=script&lang=js&"
import style0 from "./PsAdministrationPanel.vue?vue&type=style&index=0&id=e2e9eeea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e9eeea",
  null
  
)

export default component.exports